import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { from, Observable, of } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { CommunityAuthService } from '../services/community-auth.service';
import { environment, OAuthConfig } from '../../environments/environment';

//([a-ln-zA-LN-Z].*|m[b-zB-Z].*|ma[a-rT-ZA-RT-Z].*|mas[a-su-zA-SU-Z].*|mast[a-df-zA-DF-Z].*|maste[a-qs-zA-QS-Z].*)
@Injectable()
export class AuthGuard  {
    constructor(
        private oauthService: OAuthService,
        private authService: CommunityAuthService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
      ): Observable<boolean> {
        this.oauthService.configure(OAuthConfig);
        //this.oauthService.events.subscribe(e => console.log("event, e", e));
        // return from(this.oauthService.tryLoginCodeFlow())
        //     .pipe(
        //         switchMap(_ => this.authService.isDoneLoading$),
        //         filter(isDone => isDone),
        //         switchMap(_ => this.authService.isAuthenticated$),
        //         tap(isAuth => { if (! isAuth) this.authService.login(state.url.startsWith("/unauthorized") ? "/" : state.url) })
        //     );
        return from(this.oauthService.tryLoginCodeFlow())
            .pipe(switchMap(f => of(this.oauthService.hasValidAccessToken())));


    //     this.authService.login()
    //     return of(new Promise((resolve, reject) => {
    //        this.oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
    //     if (!this.oauthService.hasValidIdToken() || !this.oauthService.hasValidAccessToken()) {
    //       // Store the current URL as the state to redirect back to after login
    //       const path = route.url.toString();
    //       this.oauthService.initCodeFlow(path);
    //       reject('Login required' + path);
    //     } else {
    //       // Redirect to the original URL stored in state
    //       const state = this.oauthService.state;
    //       if (state) {
    //         this.router.navigateByUrl(decodeURIComponent(state));
    //       } else {
    //         router.navigateByUrl('/');
    //       }
    //       resolve(null);
    //     }
    //   }).catch(err => {
    //     reject(err);
    //   });
    // }));
    }
}
